/* eslint-disable @typescript-eslint/no-unused-vars */
import { SECUNDARIO, TERCIARIO } from "src/styles/styles"
import { Ipageable } from "./general"

export enum EstadoProyecto {
    ACTIVO = 'ACTIVO',
    ELIMINADO = 'ELIMINADO',
    SUSPENDIDO = 'SUSPENDIDO',
    FINALIZADO = 'FINALIZADO',
}

export const EstadoProyectoProps = {
    [EstadoProyecto.ACTIVO]: { label: 'Activo', color: SECUNDARIO },
    [EstadoProyecto.ELIMINADO]: { label: 'Eliminado', color: 'red' },
    [EstadoProyecto.SUSPENDIDO]: { label: 'Suspendido', color: '#FFA800' },
    [EstadoProyecto.FINALIZADO]: { label: 'Finalizado', color: TERCIARIO },
}

export type IobtenerProyectosRequest = {
    estado?: EstadoProyecto,
    textoSearch?: string,
    paginador?: Ipageable
}

export type IitemProyectoResponse = {
    proyectoId: string
    codigo: string
    nombre: string
    codigoPep: string
    estado: EstadoProyecto
    centroCostoId: string
    centroCosto: string
    fechaInicio: string
    fechaFinalizacion: string
    diasRestantes: number
  }

export type IobtenerProyectosResponse = {
    result: IitemProyectoResponse[];
    total: number;
    page: number;
    returnedRecords: number;
}

// Detalle de proyecto
export type IdetalleProyectoRequest = {
    proyectoId: string
}

export type IproyectoResponse = {
    proyectoId: string
    codigo: string
    nombre: string
    codigoPep: string
    estado: EstadoProyecto
    centroCostoId: string
    centroCosto: string
    fechaInicio: string
    fechaFinalizacion: string
    observaciones: string
    objeto: string
    propuestaId: string
    diasRestantes: number
}

// Informacion detallada de proyecto
export type IinfoProyectoRequest = {
    proyectoId: string
}

export type IinfoProyectoResponse = {
    proyectoId: string
    codigo: string
    nombre: string
    codigoPep: string
    estado: string
    centroCostoId: string
    centroCosto: string
    fechaInicio: string
    fechaFinalizacion: string
    observaciones: string
    objeto: string
    propuestaId: string
    totalProductos: number
    totalProductosEnProceso: number
    totalProductosFinalizados: number
    totalProductosRetrasados: number
    codigoSap: string
    programaAcademicoRelacionadoId: string
    grupoRelacionadoEjecucionId: string
    municipioEjecucionId: string
    diasRestantes: number
  }
  